import { DrawingInputField } from 'core/components';
import cx from 'classnames';
import styles from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const Illustration = ({
  blockId,
  blockData,
  blockResponse,
  onResponseChange,
  readOnly,
  reviewMode,
  showExample,
}) => {
  const getDoc = (showExample) => {
    if (showExample && blockData.example_response) {
      return blockData.example_response.submitted_drawing_json;
    }
    if (blockResponse?.submitted_drawing_json) {
      return blockResponse.submitted_drawing_json;
    }
    if (blockData?.init_response?.submitted_drawing_json) {
      return blockData.init_response.submitted_drawing_json;
    }
    return null;
  };

  return (
    <div
      className={cx({
        [styles.readOnly]: readOnly || reviewMode || showExample,
      })}
    >
      <DrawingInputField
        readOnly={readOnly || reviewMode || showExample}
        tldrawDocument={getDoc()}
        onPersist={(document_json, document_svg) => {
          onResponseChange({
            submitted_drawing_json: document_json,
            submitted_drawing_svg: document_svg,
          });
        }}
      />
    </div>
  );
};
